require("navigation");

new WOW().init();

var navHeight = 0;
var contHeight = 0;
var mapHeight = 0;

function init_blockMap() {
	if($('.fxlat').length) {
		navHeight = $('.nav').height() + $('.search-container').height() - 10;
		$('.fxlat').css('top', navHeight + 'px');
		wHeight = window.innerHeight - parseInt($('.fxlat').css('top'));
		$('.fxlat').css('min-height', wHeight + 'px');
		$('.buy-search #listingMap').css('height', wHeight + 'px');
		$('.prop-details-infosbar-container').css('min-height', wHeight + 'px');
		$('.consd-infosbar-container').css('min-height', wHeight + 'px');
	}
}

// si scrolltop + mapHeight > contHeight

function checkMapPos() {
	if($('.fxlat').length) {
		mapHeight = $('.fxlat').height();
		contHeight = $('.spkcont').height();
		if($(window).scrollTop() + mapHeight > contHeight) {
			$('.fxlat').css('top', 'inherit');
			$('.fxlat').css('position', 'absolute');
			$('.fxlat').css('bottom', '0');

		} else {
			init_blockMap();
			$('.fxlat').css('position', '');
			$('.fxlat').css('bottom', '');
		}
	}
}




/*
Script utilisé dans la iframe de la page "estimer"
<script>window.parent.postMessage('unlock', '*');</script>
*/

window.addEventListener('message', function(e) {
	if(e.data == 'unlock'){
		$('body').addClass('unlocked');
	}
});



function getAttentionUser() {
	var linkPage = $('body a:not(#cookies a)');
	var hrefValue = "";

	var modal = $("#modal-no-quit");
	var wait = $("#modal-no-quit button");
	var quit = $("#modal-no-quit a");
	var crossClose = $("#modal-no-quit #modal-close");
	var firstQuit = true;
	

// si c'est la première fois que l'utilisateur veut quitter
if (firstQuit) {

		// La souris a quitter la page
		//  $('body').on('mouseleave', function() {
		// 	// Act on the event 
		// 	modal.fadeIn(400);
		// 	hrefValue = "";
		// }); 

		

		// L'utilisateur a cliqué sur un lien
		linkPage.on('click', function(event) {

			if(!$('body').hasClass('unlocked')){


				if( !$(this).hasClass('modal-link-quit') ) {
					event.preventDefault();
				}

				/* Act on the event */
				hrefValue = $(this).attr('href');
				quit.attr('href', hrefValue);
				modal.fadeIn(400);
			}
			
		});

		wait.on('click', function(event) {
			event.preventDefault();
			/* Act on the event */
			modal.fadeOut(400);
		});

		crossClose.on('click', function(event) {
			event.preventDefault();
			/* Act on the event */
			modal.fadeOut(400);
		});
		
	}
}


$(document).ready(function(){
	if (window.innerWidth > 992) {
		init_blockMap();
		checkMapPos();
	}
	if ( $('body').hasClass('estimation')  ) {
		getAttentionUser();
	}

});

$(window).scroll(function() {    
	if (window.innerWidth > 992) {
		checkMapPos();
	}
});

$(window).load(function() {    
	if (window.innerWidth > 992) {
		init_blockMap();
		checkMapPos();
	}
});

$(".property-img-nav").on('click',function(event){
	event.preventDefault();
	var target = $(this).data('target');
	$('.prop-details-carousel-container').removeClass('displayed');
	if($("#target")){
		$(this).parent().fadeOut(400,function(){
			$("#"+target).fadeIn();
			$("#"+target).addClass('displayed');
		});
	}
});

var element = document.getElementById('carousel');
var mc = new Hammer(element);

mc.on("swiperight", function(event) {
	var that = $('.prop-details-carousel-container.displayed');
	var target = $(that).find('.property-img-nav-prev').data('target');
	$('.prop-details-carousel-container').removeClass('displayed');
	if($("#target")){
		$(that).fadeOut(400,function(){
			$("#"+target).fadeIn();
			$("#"+target).addClass('displayed');
		});
	}
});

mc.on("swipeleft", function(event) {
	var that = $('.prop-details-carousel-container.displayed');
	var target = $(that).find('.property-img-nav-next').data('target');
	$('.prop-details-carousel-container').removeClass('displayed');
	if($("#target")){
		$(that).fadeOut(400,function(){
			$("#"+target).fadeIn();
			$("#"+target).addClass('displayed');
		});
	}
});

if (window.innerWidth < 992) {
	$('.share-btn').on('click',function(){
		$('.share-btn-btns').css('display','block')
	});
}

